export default __webpack_public_path__ + "static/media/logo drishti.49fc1798.webp";